export const barHeightClassName = "h-[60px]";
